"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavLink = void 0;

var _react = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRouter = require("react-router");

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _navPath = require("./navPath");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

class NavLink extends _react.Component {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.navigateTo(this.props.to);
    this.props.updateNavPath('/');
  }

  render() {
    let props = {};
    Object.keys(this.props).map(key => {
      if (/^[a-z]+$/g.test(key)) {
        props[key] = this.props[key];
      }
    });

    if (this.props.className) {
      props.className = this.props.className;
    }

    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, _extends({
      onClick: this.handleClick
    }, props));
  }

}

exports.NavLink = NavLink;

const mapStateToProps = state => state.navPath;

const mapDispatchToProps = dispatch => (0, _redux.bindActionCreators)({
  updateNavPath: _navPath.updateNavPath,
  navigateTo: _navPath.navigateTo
}, dispatch);

var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavLink));

exports.default = _default;